import React, { useContext, useEffect, useState, forwardRef } from 'react';
import { observer } from "mobx-react-lite";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Context } from "../../../../index";
import { fetchAllPlaces } from "../../../../http/placesApi";
import {
    ABOUT_US_ROUTE,
    BLOG_ROUTE,
    MAIN_ROUTE,
    PHOTO_GALLERY_ROUTE,
    PLACES_ROUTE,
    PROFILE_ROUTE,
    SHOP_ROUTE
} from "../../../../utils/consts";
import PlaceNavItem from "../../../places/PlaceNavItem/PlaceNavItem";
import ErrorForm from "../../../modals/UserForms/ErrorForm/ErrorForm";
import FormSelection from "../../../modals/UserForms/FormSelection/FormSelection";
import { reachGoal } from "../../../../utils/metrika/metrika";
import ModalPortal from "../../../../utils/ModalPortal";

import burgerMenu from "../../../../Assets/utils/burger.svg";
import backArrow from "../../../../Assets/utils/backArrow.svg";

import styles from './Navigation.module.css';
import ExploreMenu from "../../MobileBottomNav/ExploreMenu/ExploreMenu";

const Navigation = observer(forwardRef((props, ref) => {
    const location = useLocation();
    const history = useHistory();
    const { id: profileIdParam } = useParams();

    const isFavouritesPage = location.pathname === '/favourites';
    const isMapSearchPage = location.pathname.startsWith('/map_search');
    const { add, helper, user } = useContext(Context);

    const [formSelectionVisible, setFormSelectionVisible] = useState(false);
    const [errorActive, setErrorActive] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [activePath, setActivePath] = useState('');
    const [isExploreOpen, setIsExploreOpen] = useState(false);

    const myUserId = user?.UserData?.id;
    const isProfilePage = location.pathname.startsWith(PROFILE_ROUTE);

    const isMyProfile =
        isProfilePage &&
        user?.isAuth &&
        (
            !profileIdParam || String(profileIdParam) === String(myUserId)
        );

    const [isPlacesMenuOpen, setIsPlacesMenuOpen] = useState(false);
    const [placesMenuCategory, setPlacesMenuCategory] = useState('architecture');

    const getPlacesCategoryFromPath = (pathname) => {
        if (pathname.startsWith(`${PLACES_ROUTE}/history`)) return 'history';
        if (pathname.startsWith(`${PLACES_ROUTE}/natural`)) return 'natural';
        if (pathname.startsWith(`${PLACES_ROUTE}/architecture`)) return 'architecture';
        if (pathname.startsWith(`${PLACES_ROUTE}/leisure`)) return 'leisure';
        return 'architecture';
    };

    const handlePlacesCategoryClick = (category, path) => {
        setPlacesMenuCategory(category);
        setIsPlacesMenuOpen(false);
        history.push(path);
        reachGoal(`history.push(${path}) NAVIGATION`);
    };

    useEffect(() => {
        setActivePath(location.pathname);
    }, [location.pathname]);

    useEffect(() => {
        setPlacesMenuCategory(getPlacesCategoryFromPath(location.pathname));
    }, [location.pathname]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchAllPlaces();
                add.setPlaces(data.rows);
            } catch (error) {
                setAlertText('Ошибка при загрузке данных');
                setErrorActive(true);
            }
        };

        fetchData();
    }, [add]);

    const navBarHeight = Number(helper.navBarHeight) - 1;

    const containerStyles = {
        marginTop: isFavouritesPage ? `${navBarHeight}px` : `-1px`
    };

    const handlePush = (path, goalText = "NAVIGATION") => {
        history.push(path);
        reachGoal(`history.push(${path}) ${goalText}`);
    };

    const renderPlacesPanel = () => {
        switch (placesMenuCategory) {
            case 'history':
                return (
                    <div className={styles.placesLinksGroup}>
                        <div className={styles.placesSingleLink}>
                            <a
                                onClick={() => {
                                    setIsPlacesMenuOpen(false);
                                    history.push(`${PLACES_ROUTE}/history`);
                                    reachGoal(`history.push(${PLACES_ROUTE}/history) NAVIGATION`);
                                }}
                            >
                                Перейти в раздел
                            </a>
                        </div>
                    </div>
                );

            case 'natural':
                return (
                    <div className={styles.placesLinksGroup}>
                        {add.places.slice(1, 9).map(place => (
                            <div
                                key={place.id}
                                className={styles.placeLinkRow}
                                onClick={() => setIsPlacesMenuOpen(false)}
                            >
                                <PlaceNavItem place={place} />
                            </div>
                        ))}
                    </div>
                );

            case 'architecture':
                return (
                    <div className={styles.placesLinksGroup}>
                        {add.places.slice(9, 22).map(place => (
                            <div
                                key={place.id}
                                className={styles.placeLinkRow}
                                onClick={() => setIsPlacesMenuOpen(false)}
                            >
                                <PlaceNavItem place={place} />
                            </div>
                        ))}
                    </div>
                );

            case 'leisure':
                return (
                    <div className={styles.placesLinksGroup}>
                        {add.places.slice(22, 34).map(place => (
                            <div
                                key={place.id}
                                className={styles.placeLinkRow}
                                onClick={() => setIsPlacesMenuOpen(false)}
                            >
                                <PlaceNavItem place={place} />
                            </div>
                        ))}
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <>
            <div
                className={`${styles.mainMenuContainer} ${isFavouritesPage ? styles.favouritesPageMod : ''}`}
                ref={ref}
                style={containerStyles}
            >
                <div className="container-custom">
                    <div className={styles.mainMenu}>
                        <ul className={styles.subMainMenu}>
                            <li className={`${styles.menuItem} ${activePath === MAIN_ROUTE ? styles.activeMenuItem : ''}`}>
                                <a
                                    onClick={() => handlePush(MAIN_ROUTE)}
                                >
                                    Главная
                                </a>
                            </li>

                            <li
                                className={`${styles.menuItem} ${
                                    activePath === SHOP_ROUTE || isMapSearchPage ? styles.activeMenuItem : ''
                                }`}
                            >
                                <a
                                    onClick={() => handlePush(SHOP_ROUTE)}
                                >
                                    Жилье
                                </a>
                            </li>

                            <li
                                className={`${styles.menuItem} ${styles.menuItemPlaces} ${activePath.startsWith(PLACES_ROUTE) ? styles.activeMenuItem : ''}`}
                                onMouseEnter={() => {
                                    setPlacesMenuCategory(getPlacesCategoryFromPath(location.pathname));
                                    setIsPlacesMenuOpen(true);
                                }}
                                onMouseLeave={() => setIsPlacesMenuOpen(false)}
                            >
                                <a
                                    onClick={() => {
                                        setIsPlacesMenuOpen(false);
                                        history.push(PLACES_ROUTE);
                                        reachGoal(`history.push(${PLACES_ROUTE}) NAVIGATION`);
                                    }}
                                >
                                    Интересные места
                                </a>

                                {isPlacesMenuOpen && (
                                    <div className={styles.placesMegaMenu}>
                                        <div className={styles.placesMegaInner}>
                                            <div className={styles.placesMegaLayout}>
                                                <div className={styles.placesCategories}>
                                                    <a
                                                        className={`${styles.placesCategoryLink} ${placesMenuCategory === 'history' ? styles.placesCategoryActive : ''}`}
                                                        onMouseEnter={() => setPlacesMenuCategory('history')}
                                                        onClick={() => handlePlacesCategoryClick('history', `${PLACES_ROUTE}/history`)}
                                                    >
                                                        История развития города
                                                    </a>

                                                    <a
                                                        className={`${styles.placesCategoryLink} ${placesMenuCategory === 'natural' ? styles.placesCategoryActive : ''}`}
                                                        onMouseEnter={() => setPlacesMenuCategory('natural')}
                                                        onClick={() => handlePlacesCategoryClick('natural', `${PLACES_ROUTE}/natural`)}
                                                    >
                                                        Природные богатства
                                                    </a>

                                                    <a
                                                        className={`${styles.placesCategoryLink} ${placesMenuCategory === 'architecture' ? styles.placesCategoryActive : ''}`}
                                                        onMouseEnter={() => setPlacesMenuCategory('architecture')}
                                                        onClick={() => handlePlacesCategoryClick('architecture', `${PLACES_ROUTE}/architecture`)}
                                                    >
                                                        Архитектура и искусство
                                                    </a>

                                                    <a
                                                        className={`${styles.placesCategoryLink} ${placesMenuCategory === 'leisure' ? styles.placesCategoryActive : ''}`}
                                                        onMouseEnter={() => setPlacesMenuCategory('leisure')}
                                                        onClick={() => handlePlacesCategoryClick('leisure', `${PLACES_ROUTE}/leisure`)}
                                                    >
                                                        Досуг
                                                    </a>
                                                </div>

                                                <div className={styles.placesLinksPanel}>
                                                    {renderPlacesPanel()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </li>

                            <li className={`${styles.menuItem} ${activePath === PHOTO_GALLERY_ROUTE ? styles.activeMenuItem : ''}`}>
                                <a
                                    onClick={() => handlePush(PHOTO_GALLERY_ROUTE)}
                                >
                                    Фотогалерея
                                </a>
                            </li>

                            <li className={`${styles.menuItem} ${activePath === BLOG_ROUTE ? styles.activeMenuItem : ''}`}>
                                <a
                                    onClick={() => handlePush(BLOG_ROUTE)}
                                >
                                    Блог
                                </a>
                            </li>

                            <li className={`${styles.menuItem} ${activePath.startsWith(ABOUT_US_ROUTE) ? styles.activeMenuItem : ''}`}>
                                <a
                                    onClick={() => handlePush(ABOUT_US_ROUTE)}
                                >
                                    О нас
                                </a>

                                <ul className={styles.submenu}>
                                    <li>
                                        <a onClick={() => handlePush(ABOUT_US_ROUTE)}>Информация</a>
                                    </li>
                                    <li>
                                        <a onClick={() => handlePush(ABOUT_US_ROUTE)}>Дорожная карта</a>
                                    </li>
                                    <li>
                                        <a onClick={() => handlePush(ABOUT_US_ROUTE)}>Правовая информация</a>
                                    </li>
                                    <li>
                                        <a onClick={() => handlePush(ABOUT_US_ROUTE)}>Контакты</a>
                                    </li>
                                    <li>
                                        <a onClick={() => handlePush(ABOUT_US_ROUTE)}>Тарифы</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <div className={styles.selectionButtonWrapper}>
                            <div className={styles.mobileExploreWrapper}>
                                {(() => {
                                    const path = location.pathname;

                                    if (path === SHOP_ROUTE) {
                                        return null;
                                    }

                                    const showBurger =
                                        path === MAIN_ROUTE ||
                                        (path.startsWith(PROFILE_ROUTE) && isMyProfile);

                                    if (showBurger) {
                                        return (
                                            <button
                                                className={styles.exploreTrigger}
                                                onClick={() => setIsExploreOpen(true)}
                                            >
                                                <div className={styles.burgerIcon}>
                                                    <img src={burgerMenu} alt="Меню" className={styles.exploreIcon}/>
                                                </div>
                                            </button>
                                        );
                                    }

                                    return (
                                        <button
                                            className={styles.exploreTrigger}
                                            onClick={() => history.goBack()}
                                        >
                                            <div className={styles.burgerIcon}>
                                                <img
                                                    src={backArrow}
                                                    alt="Назад"
                                                    className={styles.exploreIcon}
                                                    style={{width: '24px'}}
                                                />
                                            </div>
                                        </button>
                                    );
                                })()}
                            </div>

                            <button
                                className={styles.selectionButton}
                                onClick={() => {
                                    setFormSelectionVisible(true);
                                    reachGoal("setFormSelectionVisible(true) NAVIGATION");
                                }}
                            >
                                <span className={styles.buttonTextSmall}>Бесплатный подбор</span>
                                <span className={styles.buttonTextBig}>Бесплатный подбор жилья</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ModalPortal>
                <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)} />
            </ModalPortal>

            <ModalPortal>
                <ExploreMenu show={isExploreOpen} onClose={() => setIsExploreOpen(false)} />
            </ModalPortal>

            <ErrorForm alert={alertText} show={errorActive} onHide={() => setErrorActive(false)} />
        </>
    );
}));

export default Navigation;